<template>
	<section id="features" class="py-4">
		<div class="row mb-5">
			<h1 class="mt-5">FEATURES <span>WE OFFER</span></h1>
		</div>


		<div class="col-lg-10 col-md-10 offset-lg-1 offset-md-1 features my-5">
			<div class="row">
				<div class="feature col-md-4 col-sm-6 mb-5" :key="feature.id" v-for="feature in features">
					<h3>{{ feature.name }}</h3>

					<p>{{ feature.description }}</p>
				</div>
			</div>


		</div>
	</section>
</template>

<script>
export default {
	name: "FeatureSection",
	data() {
		return {
			launchDate: new Date("2022-03-23"),
			activeFeature: {},
			features: [
				{
					id: 0,
					available_at: "2022-03-23",
					name: "Drag & Drop Creator",
					icon: "fa-check",
					description: "Our simple, intuitive drag-and-drop builder will enable you to create your metaverse quickly and easily - with no coding experience required! Anything from a simple room to a full social, retail or entire virtual world is within reach.",
					src: ""
				},
				{
					id: 3,
					available_at: "2022-03-23",
					name: "Scalable Multiplayer",
					icon: "fa-check",
					description: "We know everything is better with friends, which is why hyper scalable multiplayer is baked into every land plot. With full support for live events & motion capture, you can make your metaverse the place to be.",
					src: ""
				},
				{
					id: 2,
					available_at: "2022-04-23",
					name: "NFT Import & Display",
					icon: "fa-check",
					description: "Already got an impressive NFT collection that you want to keep? Don’t worry - you can easily import and display them to your friends, or buy through our own marketplace.\n",
					src: ""
				},
				{
					id: 4,
					available_at: "2022-04-23",
					name: "Virtual & Augmented Reality",
					icon: "fa-check",
					description: "Augmented Reality wearables can be enabled through the AlphaBatem fabric allowing users to show off their NFT wearables and collection in both AR and VR.",
					src: ""
				},
				{
					id: 5,
					available_at: "2022-04-23",
					name: "Live Events",
					icon: "fa-check",
					description: "When we say you can bring the real world into the metaverse, we mean it! You’ll be able to host a range of live events, from corporate retreats and web conferences to music concerts and festivals, all within your virtual world.",
					src: ""
				},
				{
					id: 6,
					available_at: "2022-04-23",
					name: "Investment",
					icon: "fa-check",
					description: "The power and flexibility of our metaverse means you can create worlds with genuine utility, whether for business or pleasure. That means our plots are a true investment opportunity where you can build a virtual experience and sell it to the highest bidder.",
					src: ""
				},
			]
		}
	},
	methods: {

		isActive(feature) {
			return this.activeFeature.id === feature.id;
		},

		isAvailable(feature) {
			return this.launchDate >= new Date(feature.available_at).getTime();
		},

		setActiveFeature(feature) {
			this.activeFeature = feature;
		}
	},
	mounted() {
		this.activeFeature = this.features[0];
	},
}
</script>

<style scoped>

h1 {
	color: #0085FE;
	text-align: center;
}

h1 span {
	color: #45CE7E;
}

.alert-info {
	color: white;
	font-weight: bold;
	background: rgba(0, 0, 0, 0.1);
	cursor: pointer;
	border: 2px solid white;
}

.alert-info.active {
	border: 2px solid #0a9fb9;
}

.blue {
	color: #0a9fb9
}

.alert-info:hover {
	background: rgba(0, 0, 0, 0.8);
}

.feature {
	color: black !important;
}

.feature h3 {
	text-transform: uppercase;
	font-weight: bold;
	font-size: 1.2em;
}

.features .feature:nth-child(1) h3,
.features .feature:nth-child(2) h3,
.features .feature:nth-child(3) h3,
.features .feature:nth-child(4) h3,
.features .feature:nth-child(5) h3,
.features .feature:nth-child(6) h3 {
	padding-left: 15px;
	border-left: 5px solid #45CE7E;
}


</style>